<template>
  <div class="re-overlay" @click.self="$emit('close')">
    <div class="re-modal">
      <div class="re-hdr">
        <span>重新提交审核 · {{ companyName }}</span>
        <button class="re-close" @click="$emit('close')">✕</button>
      </div>
      <div class="re-body">
        <div class="re-opt">
          <div class="ro-t">选择重新提交的审核环节</div>
          <div class="ro-d">整改完成后，可将资料提交至客服或风控复核，已通过环节记录保留</div>
        </div>
        <label class="fld-lbl"><span class="req">*</span>提交至</label>
        <el-radio-group v-model="toStage">
          <el-radio label="CS">提交至客服</el-radio>
          <el-radio label="RISK">提交至风控</el-radio>
        </el-radio-group>
      </div>
      <div class="re-footer">
        <el-button size="small" @click="$emit('close')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="onConfirm">确认提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResubmitDialog",
  props: { companyName: { type: String, default: "" } },
  data() {
    return { toStage: "CS", loading: false };
  },
  methods: {
    onConfirm() {
      this.loading = true;
      this.$emit("confirm", { action: "RESUBMIT", toStage: this.toStage });
    }
  }
};
</script>

<style lang="scss" scoped>
.re-overlay { position: fixed; inset: 0; background: rgba(13,17,30,0.45); z-index: 2100; display: flex; align-items: flex-start; justify-content: center; padding: 6vh 18px 18px; overflow-y: auto; }
.re-modal { background: #fff; border-radius: 14px; width: 480px; max-width: 100%; box-shadow: 0 24px 64px -12px rgba(16,24,40,0.35); }
.re-hdr { display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; border-bottom: 1px solid #f1f5f9; font-size: 15px; font-weight: 700; }
.re-close { width: 28px; height: 28px; border-radius: 7px; border: 1px solid #e2e8f0; background: #fff; cursor: pointer; font-size: 12px; color: #64748b; display: flex; align-items: center; justify-content: center; }
.re-close:hover { background: #f1f5f9; color: #0f172a; }
.re-body { padding: 18px; }
.re-opt { border: 1.5px solid #426df0; background: #f7f9ff; border-radius: 11px; padding: 12px 14px; margin-bottom: 16px; }
.re-opt .ro-t { font-weight: 700; font-size: 13px; margin-bottom: 4px; }
.re-opt .ro-d { font-size: 11px; color: #64748b; line-height: 1.5; }
.fld-lbl { font-size: 12.5px; font-weight: 500; color: #334155; margin-bottom: 7px; display: block; }
.fld-lbl .req { color: #ef4444; }
.re-footer { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 18px; border-top: 1px solid #f1f5f9; background: #fafbfd; border-radius: 0 0 14px 14px; }
</style>
